export function forceRedirectToIndex() {
  // Wykonujemy przeładowanie strony aby pobrać nowy token - "twardy" reset aplikacji
  window.location.href = "/"
}
